import React, {Component} from 'react';
import {
    View,
    TextInput,
    BackHandler,
    Alert,
    Image,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    ImageBackground,
    NativeModules,
    FlatList,
    Text, I18nManager

} from "react-native"
import {typeExport} from "../redux/store/type";
import {moderateScale} from "../tools/Scaling";
import * as Colors from "../tools/Colors";
import FontAwesomeIcon from 'react-native-vector-icons/dist/FontAwesome';
import Ionicons from 'react-native-vector-icons/dist/Ionicons';
import AntDesign from 'react-native-vector-icons/dist/AntDesign';
import Entypo from 'react-native-vector-icons/dist/Entypo';
import EvilIcons from 'react-native-vector-icons/dist/EvilIcons';
import Feather from 'react-native-vector-icons/dist/Feather';
import Foundation from 'react-native-vector-icons/dist/Foundation';
import MaterialCommunityIcons from 'react-native-vector-icons/dist/MaterialCommunityIcons';
import Octicons from 'react-native-vector-icons/dist/Octicons';
import SimpleLineIcons from 'react-native-vector-icons/dist/SimpleLineIcons';
import Zocial from 'react-native-vector-icons/dist/Zocial';
import MaterialIcons from 'react-native-vector-icons/dist/MaterialIcons';
import HMSvgUri from "./svg/HMSvgUri";

export default class HMIcon extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // value: 'احمد'
        }
    }

    componentWillReceiveProps(props) {


    }

    componentDidMount() {
        // BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }

    componentWillUnmount() {
        //BackHandler.removeEventListener('hardwareBackPress', this.handleBackPress);
    }

    render() {
        let {onPress, styleRoot} = this.props;
        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        let ViewCustomize = onPress ? TouchableOpacity : View;
        return (
            <ViewCustomize
                onPress={onPress}
                style={styleRoot}
            >
                {
                    this.renderSwitch()
                }
            </ViewCustomize>
        );
    }

    renderSwitch() {
        let {name, type, text, styleRoot, style, cammas, color, size, source, resizeMode, svg,height,width} = this.props;
        let styleIcon = {
            color: Colors.white,
            fontSize: moderateScale(18),
            //  padding: moderateScale(4),
            alignSelf: "center",
        }


        switch (type) {
            case "FontAwesome":
                return <FontAwesomeIcon
                    color={color}
                    size={size}
                    name={name}
                    style={[styleIcon, style]}/>;

            case "MaterialIcons":
                return <MaterialIcons
                    color={color}
                    size={size}
                    name={name}
                    style={[styleIcon, style]}/>;

            case "Ionicons":
                return <Ionicons
                    color={color}
                    size={size}
                    name={name}
                    style={[styleIcon, style]}/>;
            case "AntDesign":
                return <AntDesign
                    color={color}
                    size={size}
                    name={name}
                    style={[styleIcon, style]}/>;
            case "Entypo":
                return <Entypo
                    color={color}
                    size={size}
                    name={name}
                    style={[styleIcon, style]}/>;
            case "EvilIcons":
                return <EvilIcons
                    color={color}
                    size={size}
                    name={name}
                    style={[styleIcon, style]}/>;
            case "Feather":
                return <Feather
                    color={color}
                    size={size}
                    name={name}
                    style={[styleIcon, style]}/>;
            case "Foundation":
                return <Foundation
                    color={color}
                    size={size}
                    name={name}
                    style={[styleIcon, style]}/>;
            case "MaterialCommunityIcons":
                return <MaterialCommunityIcons
                    color={color}
                    size={size}
                    name={name}
                    style={[styleIcon, style]}/>;
            case "Octicons":
                return <Octicons
                    color={color}
                    size={size}
                    name={name}
                    style={[styleIcon, style]}/>;
            case "SimpleLineIcons":
                return <SimpleLineIcons
                    color={color}
                    size={size}
                    name={name}
                    style={[styleIcon, style]}/>;
            case "Zocial":
                return <Zocial
                    color={color}
                    size={size}
                    name={name}
                    style={[styleIcon, style]}/>;
            case "svg":
                return <HMSvgUri
                    {...this.props}
                  //  svgXmlData={source}
                    source={source}
                   // width={width} height={height}

                   // style={style}
                    // svgXmlData={svg}
                />;
            case "image":
                return <Image
                    //testID='icon'
                    //  source={source}
                    //style={[style]}
                    //  resizeMode={resizeMode ? resizeMode : 'contain'}
                    {...this.props}
                />;


            default:
                return <Ionicons
                    color={color}
                    size={size}
                    name={name}
                    style={[styleIcon, style]}/>;

        }


    }

}
